// EXTERNAL
import ReactGA from "react-ga4";
// CONFIG
import config from "../configs/config";

type AnalyticsEventType = {
  name: string;
  category: string;
  action: string;
  label: string | undefined;
  value?: number | undefined;
};
/**
 * HTL (17-07-23)
 * Wrapper for Google Analytics.
 * Events only recorded if the environment is 'production'.
 */
export function Google_Analytics_Event({ name, category, action, label, value = 0 }: AnalyticsEventType) {
  if (config.environment === "production") {
    ReactGA.event(name, {
      category,
      action,
      label,
      value,
      transport: "beacon",
    });
  }
}
